export default __webpack_public_path__ + "5ad9d95bca69bf1feb3dc9e36991a172.svg";